<template>
  <div v-if="statement" class="flex gap-x-4 mt-4">
    <date-range
      v-model="dateRange"
      variant="narrow"
      :errors="errors"
    />
  </div>
</template>

<script lang="ts" setup>
import { useVModel } from '@vueuse/core';
import DateRange from '@components/utils/inputs/DateRange.vue';
import {ref, watch} from 'vue';
import type { FilterPrototype, LogicStatement, MaybeHydra } from '@/entities/Entities';

interface Props {
  modelValue?: MaybeHydra<
    LogicStatement<{
        start: Date;
        end: Date;
    }>
  >;
  prototype: FilterPrototype<{ from: string, to: string }, Record<string, never>>;
  errors?: object;
  disabled?: boolean;
}

const props = defineProps<Props>();

const emit = defineEmits(['update:modelValue']);
const statement = useVModel(props, 'modelValue', emit, { passive: true });

const dateRange = ref({
  start: statement.value?.data?.start ? new Date(statement.value?.data?.start) : undefined,
  end: statement.value?.data?.end ? new Date(statement.value?.data?.end) : undefined,
});

watch(() => dateRange.value, (value) => {
  if (statement.value) {
    statement.value.data.start = value.start;
    statement.value.data.end = value.end;
  }
});

statement.value.data.start = dateRange.value.start;
statement.value.data.end = dateRange.value.end;
</script>

<style lang="scss" scoped></style>
